import React from 'react';

import {
  Grid,
  Link,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography
} from '@mui/material';
import {
  NetSuiteRecordChip,
  routeDirectory
} from 'modules/layer00';

import * as dataService from './dataService';



export type IField = 'nsRma' | 'rmaNumber' | 'orderDate';

export interface IProps {
  returnAuthorizationId: string;
  fieldsToHide?: IField[];
  hideLineItems?: boolean;
}

export const FC: React.FC<IProps> = ({ returnAuthorizationId, fieldsToHide, hideLineItems }) => {
  const queryTuple = dataService.useQuery(returnAuthorizationId);

  const returnAuthorization = queryTuple.data.returnAuthorization;
  return returnAuthorization ? (
    <Grid
      container
      spacing={2}>
      <Grid
        item
        xs={2}>
        <Typography>Customer Name</Typography>
      </Grid>
      <Grid
        item
        xs={4}>
        <Link
          href={routeDirectory.admin.customers.path(returnAuthorization.customerId ?? '')}
          target="_blank">
          {returnAuthorization.customerFullName ?? ''}
        </Link>
      </Grid>

      <Grid
        item
        xs={2}>
        <Typography>NS Customer</Typography>
      </Grid>
      <Grid
        item
        xs={4}>
        <NetSuiteRecordChip.FC writeStatus={returnAuthorization.customerWriteStatus} />
      </Grid>

      <Grid
        item
        xs={2}>
        <Typography>Order Number</Typography>
      </Grid>
      <Grid
        item
        xs={4}>
        <Link
          href={routeDirectory.partner.storeDetail.path(returnAuthorization.storeId ?? '', returnAuthorization.orderId)}
          target="_blank">
          {returnAuthorization.orderNumber}
        </Link>
      </Grid>

      <Grid
        item
        xs={2}>
        <Typography>NS SO</Typography>
      </Grid>
      <Grid
        item
        xs={4}>
        <NetSuiteRecordChip.FC writeStatus={returnAuthorization.orderWriteStatus} />
      </Grid>

      {!fieldsToHide?.includes('orderDate') && (
        <>
          <Grid
            item
            xs={2}>
            <Typography>Order Date</Typography>
          </Grid>
          <Grid
            item
            xs={4}>
            <Typography>{returnAuthorization.orderDate.toFormat('MM/d/yyyy')}</Typography>
          </Grid>
        </>)}

      {!fieldsToHide?.includes('rmaNumber') && (
        <>
          <Grid
            item
            xs={2}>
            <Typography>RMA Number</Typography>
          </Grid>
          <Grid
            item
            xs={4}>
            <Link href={routeDirectory.admin.returnAuthorizations.detail.path(returnAuthorizationId)}>
              {returnAuthorization.returnNumber}
            </Link>
          </Grid>
        </>
      )}

      {!fieldsToHide?.includes('nsRma') && (
        <>
          <Grid
            item
            xs={2}>
            <Typography>NS RMA</Typography>
          </Grid>
          <Grid
            item
            xs={4}>
            <NetSuiteRecordChip.FC writeStatus={returnAuthorization.returnAuthorizationWriteStatus} />
          </Grid>
        </>
      )}

      <Grid
        item
        xs={2}>
        <Typography>NS Fulfillment</Typography>
      </Grid>

      <Grid
        item
        xs={4}>
        <NetSuiteRecordChip.FC writeStatus={{ type: 'pending' }} />
      </Grid>

      {!hideLineItems && (
        <Grid
          item
          xs={12}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Product Name</TableCell>

                <TableCell>SKU</TableCell>

                <TableCell>Quantity</TableCell>

                <TableCell>IMEI/ICCID</TableCell>

                <TableCell>Reason for Return</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {queryTuple.data.returnAuthorization?.lineItems.map(lineItem => (
                <TableRow key={lineItem.id}>
                  <TableCell>{lineItem.productName}</TableCell>

                  <TableCell>{lineItem.sku}</TableCell>

                  <TableCell>{lineItem.quantity}</TableCell>

                  <TableCell>{lineItem.serialNumber}</TableCell>

                  <TableCell>{lineItem.reasonForReturn}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Grid>
      )}
    </Grid>
  ) : null;
};
